import { MutationTree } from 'vuex'
import { ITalkState } from '@/store/talk'
import { Types, Store, Searched, Current, Filter, Saving, Selected } from '@/store/talk/types'

const mutations: MutationTree<ITalkState> = {
  [Types.store]: (state, action: Store) => {
    state.response = action.payload
  },
  [Types.searched]: (state, action: Searched) => {
    state.searched = action.payload
  },
  [Types.current]: (state, action: Current) => {
    state.current = action.payload
  },
  [Types.filter]: (state, action: Filter) => {
    state.filter = action.payload
  },
  [Types.saving]: (state, action: Saving) => {
    state.saving = action.payload
  },
  [Types.selected]: (state, action: Selected) => {
    state.selected = action.payload
  }
}

export default mutations
